<template>
  <div class="side-menu-breadcrumb">
    <p class="side-menu-breadcrumb-txt">
      <router-link
        :to="{
          path: '../',
          hash: '#' + getPathname($route.path),
        }"
        >{{ breadSubject }}</router-link
      >
      &gt; {{ removeHtmlTag(currentUnit) }}
    </p>
  </div>
</template>

<script>
import { inject } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { removeHtmlTag, getPathname } from "@/assets/scripts/utils/url";

export default {
  name: "SideMenuBreadcrumb",
  setup() {
    const currentUnit = inject("currentUnit");
    const store = useStore();
    const breadSubject = removeHtmlTag(store.state.subject);
    const textClass = document.getElementsByClassName("side-menu-breadcrumb");
    const aElements = document.getElementsByTagName("a");
    onMounted(() => {
      changeColor();
    });

    store.subscribe((mutation) => {
      if (mutation.type === "toggleDarkMode") {
        //ダークモード切り替わり検知、表示切替
        changeColor();
      }
    });
    //ダークモードStyle切り替え
    const changeColor = () => {
      for (let i = 0; i < textClass.length; i++) {
        if (store.state.isDarkMode) {
          textClass[0].className = "side-menu-breadcrumb dark-mode";
          for (let i = 0; i < aElements.length; i++) {
            aElements[i].style.color = "var(--dark-white)";
          }
        } else {
          textClass[0].className = "side-menu-breadcrumb";
          for (let i = 0; i < aElements.length; i++) {
            aElements[i].style.color = "var(--light-black)";
          }
        }
      }
    };

    return {
      currentUnit,
      breadSubject,
      getPathname,
      removeHtmlTag,
    };
  },
};
</script>

<style scoped lang="stylus">
.side-menu-breadcrumb
  color: var(--light-black)
  width: 95%
  margin-left:2.5%
  font-size 10px
  transition: all 0.5s ease-out
  &.dark-mode
    transition: all 0.5s ease-out
    color: var(--dark-white)

a
  transition: all 0.5s ease-out
  // color var(--light-black)
  &:hover
    text-decoration none
</style>
